import React from "react";
import { Button, GridColumn, GridRow, ModalDialog, OverflowText, FlexColumn } from "designSystem/index";
import TextField from "designSystem/components/textfield/TextField";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { observer } from "mobx-react-lite";
import LoadingPlaceholder from "designSystem/components/placeholder/LoadingPlaceholder";
import { useLocale } from "designSystem/locale";

const RenameExplorationDialog = observer(() => {
	const loc = useLocale();
	const fashionInspirationStore = useManageFashionInspirationStore();
	const {
		isLoading,
		onChangeExplorationName,
		explorationName,
		openRenameExplorationDialog,
		setOpenRenameExplorationDialog,
		handleRenameExploration,
	} = fashionInspirationStore;
	const updateExplorationDialogTitle = [loc.resource("RenameExplorationTitle").toLocaleLowerCase()];

	return (
		<ModalDialog
			onClose={() => setOpenRenameExplorationDialog(false)}
			open={openRenameExplorationDialog}
			showClose
			titleRes="RenameExplorationTitle"
		>
			{{
				buttons: (
					<GridRow justifyContent="flex-end" spacing={2}>
						<Button
							design="link"
							disabled={isLoading}
							onClick={() => setOpenRenameExplorationDialog(false)}
							res="Cancel"
						/>
						<Button
							design="primary"
							disabled={isLoading}
							onClick={handleRenameExploration}
							res="Rename"
						/>
					</GridRow>
				),
				main: (
					<FlexColumn
						gap={4}
						marginBottom={8}
						minWidth={500}
						paddingTop={2}
					>
						{isLoading ? (
							<LoadingPlaceholder
								subtitleProps={{
									res: "LoadingInProgress",
									resParams: updateExplorationDialogTitle,
								}}
								titleProps={{ res: "Loading" }}
							/>
						)
							: (
								<GridColumn spacing={1}>
									<OverflowText res="NewExplorationDialogInputLabel" semiBold />
									<TextField
										fullWidth
										onChange={onChangeExplorationName}
										value={explorationName}
									/>
								</GridColumn>
							)}
					</FlexColumn>
				),
			}}
		</ModalDialog>
	);
});

export default RenameExplorationDialog;
